// extracted by mini-css-extract-plugin
export default {"mainBlock":"Footer_mainBlock__QuD-w","hoverText":"Footer_hoverText__-z7BB"};